import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_CARTORIOS = `${modulo.ARRECADACAO}/cartorios`

const actions = {
  async findCartoriosByProcesso ({ commit }, idProcesso) {
    const cartorios = await axios({
      method: 'get',
      url: `${URL_CARTORIOS}/findAllByProcesso?idProcesso=${idProcesso}`
    })
    return cartorios
  },

  async findCartorioById ({ commit }, { id }) {
    const cartorio = await axios({
      method: 'get',
      url: `${URL_CARTORIOS}?id=${id}`
    })
    return cartorio
  },

  async findCartorioByMunicipiosIds ({ commit }, idsMunicipios) {
    const cartorio = await axios({
      method: 'POST',
      data: idsMunicipios,
      url: `${URL_CARTORIOS}/findByMunicipiosIds`
    })
    return cartorio
  },

  async findSolicitacaoById ({ commit }, idSolicitacao) {
    return axios({
      method: 'GET',
      url: `${URL_CARTORIOS}/findSolicitacaoById?id=${idSolicitacao}`
    })
  },

  async findSolicitacaoByProtocolo ({ commit }, protocolo) {
    return axios({
      method: 'GET',
      url: `${URL_CARTORIOS}/findSolicitacaoByProtocolo?protocolo=${protocolo}`
    })
  },

  async visualizado ({ commit }, idMensagem) {
    return axios({
      method: 'PATCH',
      params: {origem: 'SICARF'},
      url: `${URL_CARTORIOS}/solicitacao/mensagem/visualizado/${idMensagem}`
    })
  },

  async finalizar ({ commit }, idSolicitacao) {
    return axios({
      method: 'PATCH',
      url: `${URL_CARTORIOS}/solicitacao/finalizar/${idSolicitacao}`
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/cartorioArrecadacao.js